export default {
  title: "Invito",
  description: "Sei stato invitato a collaborare su un evento",
  status: {
    pending: "In attesa",
    accepted: "Accettato",
    declined: "Rifiutato",
    expired: "Scaduto"
  },
  resourceTypes: {
    budget: "Budget",
    guests: "Ospiti",
    tasks: "Attività",
    timeline: "Cronologia",
    vendors: "Fornitori",
    events: "Eventi"
  },
  accessLevels: {
    view: "Solo visualizzazione",
    edit: "Modifica",
    manage: "Gestione completa"
  },
  actions: {
    accept: "Accetta",
    decline: "Rifiuta"
  },
  accessLevel: "Livello di accesso",
  expiresAt: "Scade il",
  invitedBy: "Invitato da",
  unknownUser: "Utente sconosciuto",
  success: {
    accepted: "Invito accettato con successo",
    declined: "Invito rifiutato"
  },
  errors: {
    invalidToken: "Token di invito non valido",
    notFound: "Invito non trovato",
    expired: "Questo invito è scaduto",
    accept: "Errore nell'accettare l'invito",
    decline: "Errore nel rifiutare l'invito",
    loadInvitation: "Errore nel caricare l'invito",
    pendingInvitation: "Errore nel verificare gli inviti in sospeso"
  },
  landing: {
    welcome: "Benvenuto, {{name}}!",
    welcomeGeneric: "Accesso Condiviso",
    subtitle: "Inserisci la tua email per accedere alle risorse condivise",
    subtitleAuthenticated: "Sei stato invitato a collaborare a questo evento.",
    confirmIdentity: "Conferma la tua identità per accedere allo spazio sicuro riservato a",
    emailLabel: "Indirizzo email",
    emailPlaceholder: "tua@email.com",
    emailHelp: "Usa l'indirizzo email con cui hai ricevuto l'invito",
    submitButton: "Accedi allo spazio",
    validating: "Validazione...",
    securityTitle: "Info sicurezza",
    securityPoint1: "Questo link è unico e sicuro",
    securityPoint2: "L'accesso è strettamente riservato all'email invitata",
    securityPoint3: "Non è richiesta la creazione di un account",
    errorToken: "Token di condivisione mancante nell'URL",
    errorValidation: "Link non valido o email errata. Verifica di utilizzare l'indirizzo email corretto.",
    errorGeneric: "Si è verificato un errore durante la convalida"
  }
};
